import * as React from 'react';
import { IS_BROWSER } from 'core/constants';
import { useLocation } from '@reach/router';
import { getClientInfo } from '../../lib/clientInfo';
import useMntnAdvertiserId from '../../hooks/useMntnAdvertiserId';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';
import Pixel from '../Pixel';

const CACHE_BUSTER = Math.floor(Math.random() * 1e17).toString(16);

export default function MntnGlobalPixel() {
    const [pixelUrl, setPixelUrl] = React.useState<string | null>(null);
    const location = useLocation();
    const clientInfo = getClientInfo();
    const { enabled, advertiserId } = useMntnAdvertiserId();
    const { analytics4Id } = useGoogleAnalytics();

    React.useEffect(() => {
        if (enabled && !!advertiserId && IS_BROWSER) {
            setTimeout(() => {
                const url = new URL('https://px.mountain.com/sti');
                url.searchParams.set('shaid', advertiserId as string);
                url.searchParams.set('cb', CACHE_BUSTER);
                url.searchParams.set('plh', location.href);
                url.searchParams.set('ga_tracking_id', analytics4Id || '');

                // Retrieve GA Client ID and append it to the URL
                const gaClientId = clientInfo?.clientId || '';
                if (gaClientId) {
                    url.searchParams.set('ga_client_id', gaClientId);
                }
                url.searchParams.set('shpt', document.title);

                setPixelUrl(url.toString());
            }, 0);
        }
    }, [
        clientInfo?.clientId,
        location.href,
        advertiserId,
        analytics4Id,
        enabled,
    ]);

    if (pixelUrl) {
        return (
            <Pixel
                src={pixelUrl}
                width="0"
                alt="mntn_tracking_pixel"
                aria-hidden="true"
                height="0"
                style={{ display: 'none' }}
                cookieType="marketing"
            />
        );
    }

    return null;
}
